import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Org {
  _id: string;
  name: string;
  members: string[];
  projects: string[];
  createdAt?: string;
  updatedAt?: string;
  break?: {
    _id: string;
    hours: number;
  };
  overtimeAllowed?: boolean;
  overtimeHours?: number;
  __v?: number;
}

export interface ImpersonableUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  position?: string;
  completedWelcome?: boolean;
  isDemo?: boolean;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
  org: Org;
}

export type ImpersonableUsersResponse = ImpersonableUser[];

const fetchImpersonableUsers = async (): Promise<ImpersonableUsersResponse> => {
  const { data } = await customAxios.get<ImpersonableUsersResponse>(
    "/users/impersonable"
  );
  return data;
};

export const useGetImpersonableUsers = () =>
  useQuery<ImpersonableUsersResponse, AxiosError>(
    ["impersonableUsers"],
    fetchImpersonableUsers,
    {
      // onError: (error) =>
      //   showNotification({
      //     title: "Error Loading Users",
      //     message:
      //       (error.response?.data as { message?: string })?.message ??
      //       "Failed to load users",
      //     color: "red",
      //   }),

      retry: 1,
      refetchOnMount: "always",
    }
  );
